export const SidebarButton = {
  controlActiveButton: (idElement, type) => {
    document.querySelectorAll(`.panel-button > button[id*=${type}]`).forEach(el => {
      if (el.id === idElement) {
        $(el).addClass('sidebar-active');
        return;
      }
      return $(el).removeClass('sidebar-active');
    });
  },

  removeActiveButton: (type) => {
    document.querySelectorAll(`.panel-button > button[id*=${type}]`).forEach(el => {
      $(el).removeClass('sidebar-active');
    });
  }
};



// WEBPACK FOOTER //
// ./src/scripts/core/sidebar/button.helper.js